/* Help Center — CORE engine. Do NOT edit. Load this FIRST. */
window.HC_CONTENT = window.HC_CONTENT || {};
window.HC_MATERIALS = window.HC_MATERIALS || [];
window.HC_MATERIAL_PAGES = window.HC_MATERIAL_PAGES || {};

// ─── UI builder ────────────────────────────────────────────────────────────

function hcBuildMaterialsUI(){
  var sidebar='';
  HC_MATERIALS.forEach(function(m){
    sidebar+='<button class="hc-mat-btn" data-matid="'+m.id+'">'+m.name+'</button>';
  });
  return '<div class="hc-mat-sidebar">'+sidebar+'</div><div class="hc-mat-detail" id="hcMatDetail"></div>';
}

function hcRenderMaterial(id){
  var m=HC_MATERIALS.find(function(x){return x.id===id;});
  if(!m) return;
  var detail=document.getElementById('hcMatDetail');
  if(!detail) return;
  document.querySelectorAll('.hc-mat-btn').forEach(function(b){
    b.classList.toggle('active',b.dataset.matid===id);
  });

  if(m.isLeatherGroup){
    var activeSub=m.subtypes[0];
    var tabs=m.subtypes.map(function(s){
      return '<button class="mp-tab'+(s.id===activeSub.id?' active':'')+'" data-subtypeid="'+s.id+'" style="margin-right:6px;">'+s.name+'</button>';
    }).join('');
    detail.innerHTML='<div class="hc-breadcrumb">Materials \u203a '+m.name+'</div><div class="imp"><div class="hero"><h1>'+m.name+'</h1></div><p class="subtitle">'+(m.tagline||'')+'</p></div><div class="mp-tabs" style="margin-bottom:16px;">'+tabs+'</div><div id="hcLeatherContent"></div>';
    var lcont=detail.querySelector('#hcLeatherContent');
    if(lcont && HC_MATERIAL_PAGES[activeSub.id]) lcont.innerHTML=HC_MATERIAL_PAGES[activeSub.id]();
    detail.querySelectorAll('[data-subtypeid]').forEach(function(btn){
      btn.addEventListener('click',function(){
        detail.querySelectorAll('[data-subtypeid]').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        var lc=detail.querySelector('#hcLeatherContent');
        if(lc && HC_MATERIAL_PAGES[btn.dataset.subtypeid]) lc.innerHTML=HC_MATERIAL_PAGES[btn.dataset.subtypeid]();
      });
    });
    return;
  }

  if(HC_MATERIAL_PAGES[id]){
    detail.innerHTML='<div class="hc-breadcrumb">Materials \u203a '+m.name+'</div>'+HC_MATERIAL_PAGES[id]();
    // Wire up inner tabs (e.g. PU faux leather)
    detail.querySelectorAll('.mp-tab[data-mptab]').forEach(function(tab){
      tab.addEventListener('click',function(){
        detail.querySelectorAll('.mp-tab[data-mptab]').forEach(function(t){t.classList.remove('active');});
        tab.classList.add('active');
        detail.querySelectorAll('.mp-tp').forEach(function(tp){tp.classList.remove('active');});
        var el=detail.querySelector('#'+tab.dataset.mptab);
        if(el) el.classList.add('active');
      });
    });
    return;
  }

  // Fallback: generic rendering from HC_MATERIALS data
  var sw=(m.colors||[]).map(function(c){
    var bg=c.hex?'background:'+c.hex+';':'';
    return '<div class="hc-swatch"><div class="hc-swatch-box" style="'+bg+'" title="'+c.name+'"></div><span class="hc-swatch-name">'+c.name+'</span></div>';
  }).join('');
  var h='<div class="hc-breadcrumb">Materials \u203a '+m.name+'</div>';
  h+='<h3>'+m.name+'</h3>';
  h+='<p class="hc-mat-tagline">'+m.tagline+'</p>';
  h+='<div class="hc-mat-section"><h4>About</h4><p>'+(m.about||'')+'</p></div>';
  h+='<div class="hc-mat-section"><h4>Colors ('+(m.colors?m.colors.length:0)+')</h4><div class="hc-color-swatches">'+sw+'</div></div>';
  h+='<div class="hc-mat-section"><h4>Texture</h4><p>'+(m.texture||'')+'</p></div>';
  if(m.branding){
    var brd=m.branding.map(function(c){return '<span class="hc-badge yes">'+c.label+'</span>';}).join('');
    h+='<div class="hc-mat-section"><h4>Branding</h4>'+brd+'<p style="margin-top:8px;">'+(m.brandingNote||'')+'</p></div>';
  } else if(m.coating){
    var bd=m.coating.map(function(c){return '<span class="hc-badge '+c.type+'">'+c.label+'</span>';}).join('');
    h+='<div class="hc-mat-section"><h4>Coating</h4>'+bd+'<p style="margin-top:8px;">'+(m.coatingNote||'')+'</p></div>';
  }
  h+='<div class="hc-mat-section"><h4>Care</h4><p>'+(m.care||'')+'</p></div>';
  detail.innerHTML=h;
}

// ─── Modal open / close ────────────────────────────────────────────────────

function hcOpen(key){
  var bg=document.getElementById('hcModalBg');
  var title=document.getElementById('hcModalTitle');
  var inner=document.getElementById('hcModalInner');
  if(!bg||!title||!inner) return;

  if(key==='materials'){
    title.textContent='Materials';
    inner.innerHTML=hcBuildMaterialsUI();
    bg.classList.add('open');
    document.body.style.overflow='hidden';
    inner.querySelectorAll('.hc-mat-btn[data-matid]').forEach(function(btn){
      btn.addEventListener('click',function(){
        hcRenderMaterial(btn.dataset.matid);
      });
    });
    if(HC_MATERIALS&&HC_MATERIALS.length) hcRenderMaterial(HC_MATERIALS[0].id);
    return;
  }

  if(HC_CONTENT&&HC_CONTENT[key]){
    title.textContent=HC_CONTENT[key].title||'—';
    inner.innerHTML=HC_CONTENT[key].html||'<div class="hc-generic-content"><p>Content not found.</p></div>';
    bg.classList.add('open');
    document.body.style.overflow='hidden';
  } else {
    title.textContent='—';
    inner.innerHTML='<div class="hc-generic-content"><p>Content not found.</p></div>';
    bg.classList.add('open');
    document.body.style.overflow='hidden';
  }
}

function hcClose(){
  var bg=document.getElementById('hcModalBg');
  if(bg) bg.classList.remove('open');
  document.body.style.overflow='';
}

// ─── Event binding ─────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded',function(){
  // Banner buttons
  document.querySelectorAll('.hc-banner[data-modal]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      hcOpen(btn.dataset.modal);
    });
  });

  // Topic cards
  document.querySelectorAll('.hc-topic[data-modal]').forEach(function(el){
    el.addEventListener('click',function(){
      hcOpen(el.dataset.modal);
    });
  });

  // Close button
  var closeBtn=document.getElementById('hcModalCloseBtn');
  if(closeBtn) closeBtn.addEventListener('click',hcClose);

  // Click on dark background closes modal
  var bg=document.getElementById('hcModalBg');
  if(bg) bg.addEventListener('click',function(e){
    if(e.target===bg) hcClose();
  });

  // Escape key
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape') hcClose();
  });
});